<div class="jeito" *ngIf="configuracoes && vista">

  <!-- Operação fora do texto: decisão de hoje, não de comportamento -->
  <header class="jeito__topo">
    <div class="jeito__identidade">
      <span class="jeito__avatar"><i class="fas fa-robot"></i></span>
      <div>
        <h1 class="jeito__titulo">{{ nomeDaMia }} <span class="jeito__selo">Jeito de atender</span></h1>
        <!-- A mesma configuração, ajuste a ajuste -->
        <p class="jeito__atalhos">
          <button type="button" class="jeito__atalho" (click)="abraConfiguracoes()">
            <i class="fas fa-sliders-h"></i> Configurações avançadas
          </button>
        </p>
      </div>
    </div>
    <div class="jeito__estado" role="radiogroup" aria-label="Status de operação">
      <button type="button" class="jeito__pill" *ngFor="let opcao of opcoesStatus; trackBy: trackPorValor"
              [class.jeito__pill--ativa]="configuracoes.status === opcao.valor"
              [attr.data-estado]="opcao.valor" [attr.aria-checked]="configuracoes.status === opcao.valor"
              role="radio" [title]="opcao.descricao" (click)="defineStatus(opcao.valor)">
        <i class="fas" [ngClass]="opcao.icone"></i> {{ opcao.nome }}
      </button>
    </div>
  </header>

  <p class="jeito__linha-estado">
    <ng-container *ngIf="configuracoes.status === 'MODO_TESTE'">
      Em teste com <strong>{{ telefones.length }} {{ telefones.length === 1 ? 'número' : 'números' }}</strong>
      <button type="button" class="jeito__link" (click)="editandoTelefones = !editandoTelefones">
        {{ editandoTelefones ? 'fechar' : 'editar' }}
      </button>
    </ng-container>
    <ng-container *ngIf="configuracoes.status === 'ATIVADA'">Atendendo todos os clientes.</ng-container>
    <ng-container *ngIf="configuracoes.status === 'DESATIVADA'">Ninguém recebe resposta automática.</ng-container>
  </p>

  <div class="jeito__teste" *ngIf="configuracoes.status === 'MODO_TESTE' && editandoTelefones">
    <p class="jeito__teste-hint">Só estes números conversam com {{ nomeDaMia }}. Número completo com DDI e DDD, sem espaços.</p>
    <div class="jeito__fichas">
      <span class="jeito__ficha" *ngFor="let telefone of telefones">
        {{ telefone }}
        <button type="button" class="jeito__ficha-x" (click)="removaTelefone(telefone)" [attr.aria-label]="'Remover ' + telefone">
          <i class="fas fa-times"></i>
        </button>
      </span>
      <input type="text" class="jeito__teste-input" [(ngModel)]="novoTelefone" placeholder="5511999999999"
             (keydown.enter)="$event.preventDefault(); adicioneTelefone()" aria-label="Novo telefone de teste"/>
      <button type="button" class="jeito__teste-add" (click)="adicioneTelefone()"><i class="fas fa-plus"></i> Adicionar</button>
    </div>
  </div>

  <div class="jeito__colunas">

    <!-- Esquerda: o que a Mia faz, em cartões ou em texto — o usuário escolhe. -->
    <main class="jeito__folha" [class.jeito__folha--cartoes]="modo === 'cartoes'">
      <h2 class="jeito__manchete">É assim que {{ nomeDaMia }} atende</h2>
      <p class="jeito__sub">Toque num {{ modo === 'cartoes' ? 'cartão' : 'trecho' }} para ir ao ajuste correspondente.</p>

      <div class="jeito__barra">
        <div class="modo" role="radiogroup" aria-label="Forma de leitura">
          <button type="button" class="modo__btn" [class.modo__btn--ativo]="modo === 'cartoes'" role="radio"
                  [attr.aria-checked]="modo === 'cartoes'" (click)="mudeModo('cartoes')">
            <i class="fas fa-th-list"></i> Cartões
          </button>
          <button type="button" class="modo__btn" [class.modo__btn--ativo]="modo === 'texto'" role="radio"
                  [attr.aria-checked]="modo === 'texto'" (click)="mudeModo('texto')">
            <i class="fas fa-align-left"></i> Texto
          </button>
        </div>
        <label class="busca">
          <i class="fas fa-search busca__icone"></i>
          <input type="search" class="busca__input" [(ngModel)]="busca" (ngModelChange)="filtre()"
                 placeholder="Buscar um ajuste (ex.: áudio, lembrete, fala demais)" aria-label="Buscar ajuste"/>
          <button type="button" class="busca__limpar" *ngIf="busca" (click)="limpeBusca()" aria-label="Limpar busca">&times;</button>
        </label>
      </div>

      <p class="jeito__vazio" *ngIf="buscaSemResultado">
        Nenhum ajuste combina com “{{ busca }}”. Tente outra palavra — ou
        <button type="button" class="jeito__link" (click)="limpeBusca()">veja tudo</button>.
      </p>

      <!-- Cartões -->
      <ng-container *ngIf="modo === 'cartoes'">
        <ng-container *ngFor="let p of paragrafosFiltrados; let n = index; trackBy: trackPorMomento">
          <h3 class="secao">{{ n + 1 }}. {{ p.titulo }}</h3>
          <ng-container *ngFor="let a of p.assuntos; trackBy: trackPorId">
            <ng-container *ngTemplateOutlet="cartao; context: {a: a}"></ng-container>
          </ng-container>
        </ng-container>
        <div class="adm" *ngIf="assuntosAdminFiltrados.length">
          <h3 class="secao secao--adm"><i class="fas fa-lock"></i> {{ tituloAdmin }}</h3>
          <ng-container *ngFor="let a of assuntosAdminFiltrados; trackBy: trackPorId">
            <ng-container *ngTemplateOutlet="cartao; context: {a: a}"></ng-container>
          </ng-container>
        </div>
      </ng-container>

      <!-- Texto corrido: seção com filete à esquerda; frase é uma caixa, valores em ficha -->
      <ng-container *ngIf="modo === 'texto'">
        <section class="trecho" *ngFor="let p of paragrafosFiltrados; trackBy: trackPorMomento">
          <h3 class="trecho__titulo">{{ p.titulo }}</h3>
          <p class="trecho__par">
            <ng-container *ngFor="let a of p.assuntos; trackBy: trackPorId">
              <ng-container *ngTemplateOutlet="fraseTexto; context: {a: a}"></ng-container>{{ ' ' }}
            </ng-container>
          </p>
        </section>
        <section class="trecho trecho--adm" *ngIf="assuntosAdminFiltrados.length">
          <h3 class="trecho__titulo"><i class="fas fa-lock"></i> {{ tituloAdmin }}</h3>
          <p class="trecho__par">
            <ng-container *ngFor="let a of assuntosAdminFiltrados; trackBy: trackPorId">
              <ng-container *ngTemplateOutlet="fraseTexto; context: {a: a}"></ng-container>{{ ' ' }}
            </ng-container>
          </p>
        </section>
      </ng-container>
    </main>

    <!-- Direita: os ajustes, nos mesmos momentos e na mesma ordem do texto -->
    <aside class="jeito__form">
      <section class="grupo" *ngFor="let p of paragrafos; trackBy: trackPorMomento">
        <h3 class="grupo__titulo">{{ p.titulo }}</h3>
        <ng-container *ngFor="let a of p.assuntos; trackBy: trackPorId">
          <ng-container *ngTemplateOutlet="bloco; context: {a: a}"></ng-container>
        </ng-container>
      </section>

      <section class="grupo grupo--adm" *ngIf="assuntosAdmin.length">
        <h3 class="grupo__titulo"><i class="fas fa-lock"></i> Motor (admin)</h3>
        <ng-container *ngFor="let a of assuntosAdmin; trackBy: trackPorId">
          <ng-container *ngTemplateOutlet="bloco; context: {a: a}"></ng-container>
        </ng-container>
      </section>
    </aside>
  </div>

  <footer class="jeito__acoes">
    <button type="button" class="btn btn-light" (click)="cancele()" [disabled]="salvando">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="salve()" [disabled]="salvando">
      {{ salvando ? 'Salvando…' : 'Salvar alterações' }}
    </button>
  </footer>
</div>

<!-- Um bloco do formulário: fechado é o título; aberto são os controles do assunto -->
<ng-template #bloco let-a="a">
  <div class="bloco" [id]="'jeito-bloco-' + a.id"
       [class.bloco--aberto]="a === assuntoAberto" [class.bloco--alterado]="assuntoAlterado(a)">
    <button type="button" class="bloco__cabeca" (click)="abrir(a)" [attr.aria-expanded]="a === assuntoAberto">
      <i class="fas bloco__seta" [ngClass]="a === assuntoAberto ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
      <span class="bloco__titulo">{{ a.titulo }}</span>
      <span class="bloco__marca" *ngIf="assuntoAlterado(a)" title="Diferente do padrão"></span>
    </button>

    <div class="bloco__corpo" *ngIf="a === assuntoAberto">
      <p class="ctl__escolhida" *ngIf="a.id === 'midia' && !configuracoes.escalarParaAtendente">
        A transferência de áudio está desligada.
        <button type="button" class="jeito__link" (click)="abraEquipe()">Ajustar ajuda da equipe</button>
      </p>
      <ng-container *ngFor="let c of controlesAbertos; trackBy: trackPorCampo">
        <ng-container [ngSwitch]="c.tipo">
          <a *ngSwitchCase="'avancado'" class="jeito__link" routerLink="/admin/chatbot/configuracoes">{{ c.rotulo }}</a>

          <label class="sw" *ngSwitchCase="'switch'">
            <kendo-switch [(ngModel)]="configuracoes[c.campo]" (ngModelChange)="aoMudar()"
                          [onLabel]="'Sim'" [offLabel]="'Não'"></kendo-switch>
            <span>{{ c.rotulo }} <small *ngIf="c.dica">{{ c.dica }}</small></span>
          </label>

          <div class="ctl" *ngSwitchCase="'escolha'">
            <p class="ctl__rot">{{ c.rotulo }}</p>
            <button type="button" class="chip" *ngFor="let o of c.opcoes; trackBy: trackPorValor"
                    [class.chip--on]="configuracoes[c.campo] === o.valor" [title]="o.descricao"
                    (click)="escolhaValor(c.campo, o.valor)">
              <i class="fas" [ngClass]="o.icone"></i> {{ o.nome }}
            </button>
            <p class="ctl__escolhida" *ngIf="opcaoEscolhidaDe(c) as o">{{ o.descricao }}<strong *ngIf="o.reforco"> {{ o.reforco }}</strong></p>
          </div>

          <div class="ctl" *ngSwitchCase="'numero'">
            <p class="ctl__rot">{{ c.rotulo }}</p>
            <input type="number" class="ctl__num" [(ngModel)]="configuracoes[c.campo]" (ngModelChange)="aoMudar()"
                   [min]="1" [attr.aria-label]="c.rotulo"/>
            <span class="ctl__un">{{ c.unidade }}</span>
          </div>

          <div class="ctl ctl--texto" *ngSwitchCase="'texto'">
            <p class="ctl__rot">{{ c.rotulo }}</p>
            <input type="text" class="ctl__txt" [(ngModel)]="configuracoes[c.campo]" (ngModelChange)="aoMudar()"
                   [maxlength]="c.maxLength || null" [placeholder]="c.placeholder || ''" [attr.aria-label]="c.rotulo"/>
            <span class="ctl__contador" *ngIf="c.maxLength">{{ (configuracoes[c.campo] || '').length }}/{{ c.maxLength }}</span>
          </div>

          <div class="ctl ctl--texto" *ngSwitchCase="'area'">
            <p class="ctl__rot">{{ c.rotulo }}</p>
            <textarea class="ctl__txt" rows="3" [(ngModel)]="configuracoes[c.campo]" (ngModelChange)="aoMudar()"
                      [maxlength]="c.maxLength || null" [placeholder]="c.placeholder || ''" [attr.aria-label]="c.rotulo"></textarea>
            <span class="ctl__contador" *ngIf="c.maxLength">{{ (configuracoes[c.campo] || '').length }}/{{ c.maxLength }}</span>
          </div>

          <div class="ctl" *ngSwitchCase="'escada'">
            <p class="ctl__rot">{{ c.rotulo }}</p>
            <ng-container *ngFor="let t of toques[c.campo]; let i = index; trackBy: trackPorIndice">
              <span class="escada__seta" *ngIf="i > 0"><i class="fas fa-arrow-right"></i></span>
              <span class="escada__chip">
                <input type="number" class="ctl__num" [(ngModel)]="toques[c.campo][i]" (ngModelChange)="aoMudar()"
                       [min]="1" [max]="60" [attr.aria-label]="'Toque ' + (i + 1)"/>
                <span class="ctl__un">min</span>
                <button type="button" class="escada__remover" *ngIf="toques[c.campo].length > 1"
                        (click)="removaToqueE(c.campo, i)" title="Remover este toque">&times;</button>
              </span>
            </ng-container>
            <button type="button" class="escada__adicionar" *ngIf="toques[c.campo].length < 3" (click)="adicioneToqueE(c.campo)">+ toque</button>
            <p class="ctl__erro" *ngIf="!escadaValida(c.campo)">Use tempos crescentes entre 1 e 60 minutos.</p>
          </div>

          <div class="ctl" *ngSwitchCase="'produtos'">
            <p class="ctl__rot">{{ c.rotulo }}</p>
            <span class="jeito__ficha" *ngFor="let produto of produtosUpsell; let i = index">
              <span class="jeito__ficha-n">{{ i + 1 }}º</span> {{ produto.nome }}
              <button type="button" class="jeito__ficha-x" (click)="removaProdutoUpsell(produto)" [attr.aria-label]="'Remover ' + produto.nome">
                <i class="fas fa-times"></i>
              </button>
            </span>
            <kendo-dropdownlist class="form-control ctl__busca" [data]="opcoesBuscaUpsell" [filterable]="true"
                                [textField]="'descricao'" [valueField]="'id'"
                                [disabled]="produtosUpsell.length >= 3"
                                [(ngModel)]="produtoUpsellSelecionado"
                                [defaultItem]="{id: null, descricao: produtosUpsell.length >= 3 ? 'Limite de 3 itens' : 'Buscar item do cardápio…'}"
                                (valueChange)="adicioneProdutoUpsell($event)"
                                (filterChange)="searchProdutoUpsell($event)"
                                (focus)="busquePrimeiraVezUpsell()">
            </kendo-dropdownlist>
          </div>

          <div class="ctl ctl--notificacao" *ngSwitchCase="'notificacao'">
            <p class="ctl__rot">{{ c.rotulo }}</p>
            <app-form-notificacao *ngIf="notificacao" [notificacao]="notificacao"></app-form-notificacao>
          </div>

        </ng-container>
      </ng-container>

      <p class="bloco__x">{{ a.explicacao }}</p>
    </div>
  </div>
</ng-template>

<!-- Um cartão: ícone, título, frase com os valores em destaque e "Editar" -->
<ng-template #cartao let-a="a">
  <div class="cartao" [class.cartao--aberto]="a === assuntoAberto" [class.cartao--alterado]="assuntoAlterado(a)"
       role="button" tabindex="0" [attr.aria-controls]="'jeito-bloco-' + a.id"
       (click)="abrirDaFrase(a)" (keydown.enter)="abrirDaFrase(a)" (keydown.space)="$event.preventDefault(); abrirDaFrase(a)">
    <span class="cartao__icone" [attr.data-cor]="a.cor">{{ a.emoji }}</span>
    <div class="cartao__texto">
      <strong class="cartao__titulo">{{ a.titulo }}</strong>
      <p class="cartao__frase">
        <ng-container *ngFor="let seg of segmentosPorId[a.id]; trackBy: trackPorIndiceSeg">
          <span class="cartao__valor" *ngIf="seg.valor; else textoSeg">{{ seg.texto }}</span>
          <ng-template #textoSeg>{{ seg.texto }}</ng-template>
        </ng-container>
      </p>
    </div>
    <span class="cartao__editar">Editar</span>
  </div>
</ng-template>

<!-- Uma frase do texto corrido: clicável inteira, com os valores configurados em ficha -->
<ng-template #fraseTexto let-a="a">
  <span class="frase" role="button" tabindex="0"
        [class.frase--aberta]="a === assuntoAberto" [class.frase--alterada]="assuntoAlterado(a)"
        [attr.aria-controls]="'jeito-bloco-' + a.id"
        (click)="abrirDaFrase(a)" (keydown.enter)="abrirDaFrase(a)"
        (keydown.space)="$event.preventDefault(); abrirDaFrase(a)"><ng-container *ngFor="let seg of segmentosPorId[a.id]; trackBy: trackPorIndiceSeg"><span class="frase__valor" *ngIf="seg.valor; else segTexto">{{ seg.texto }}</span><ng-template #segTexto>{{ seg.texto }}</ng-template></ng-container></span>
</ng-template>
